/**
 * 合成进度徽标（嵌入工作台顶部）
 *
 * 三态展示：
 *   - pending / running：黄色 spinner + 提示
 *   - completed：绿色对勾 + 时长
 *   - failed：红色，提示用户重试
 */

import { CheckCircle2, Loader2, XCircle } from 'lucide-react';
import type { DirectorComposition } from '../../services/directorApi';

interface Props {
  composition: DirectorComposition | null;
  /** 点击时的回调（通常打开预览成片对话框） */
  onClick?: () => void;
}

export function CompositionProgressBadge({ composition, onClick }: Props) {
  if (!composition) return null;

  if (composition.status === 'pending' || composition.status === 'running') {
    return (
      <button
        type="button"
        onClick={onClick}
        className="px-2.5 py-1 rounded-full text-xs flex items-center gap-1.5 bg-amber-50 text-amber-700 border border-amber-200 hover:bg-amber-100"
        title="点击查看预览"
      >
        <Loader2 className="w-3.5 h-3.5 animate-spin" />
        <span>成片合成中…</span>
      </button>
    );
  }

  if (composition.status === 'completed') {
    return (
      <button
        type="button"
        onClick={onClick}
        className="px-2.5 py-1 rounded-full text-xs flex items-center gap-1.5 bg-green-50 text-green-700 border border-green-200 hover:bg-green-100"
        title="点击预览成片"
      >
        <CheckCircle2 className="w-3.5 h-3.5" />
        <span>
          成片就绪
          {composition.resultDuration ? ` · ${composition.resultDuration.toFixed(1)}s` : ''}
        </span>
      </button>
    );
  }

  if (composition.status === 'failed') {
    return (
      <button
        type="button"
        onClick={onClick}
        className="px-2.5 py-1 rounded-full text-xs flex items-center gap-1.5 bg-red-50 text-red-700 border border-red-200 hover:bg-red-100"
        title="点击重试合成"
      >
        <XCircle className="w-3.5 h-3.5" />
        <span>合成失败，可重试</span>
      </button>
    );
  }

  return null;
}
